import Notify from './notifyActions'
export const UPLOAD_LIMITDB = 'UPLOAD_LIMITDB'
export const UPLOAD_MANUFACTURERDB = 'UPLOAD_MANUFACTURERDB'
export const UPLOAD_DEVICE_SOFTWARE = 'UPLOAD_DEVICE_SOFTWARE'
export const UPLOAD_FIBER_FILES = 'UPLOAD_FIBER_FILES'
export const UPLOAD_ADAPTER_POLICY = 'UPLOAD_ADAPTER_POLICY'

const ERROR_INCORRECT_FILE_FORMAT = "error_incorrect_file_format"
const FILE_UPLOAD_SUCCESSFULL = "file_upload_successfull"
export const uploadLimitDb = (data) => {

  return (dispatch, getState) => {
    dispatch({
      type: UPLOAD_LIMITDB,
      payload: {
        request: {
          url: `/limitparser`,
          method: 'POST',
          headers: {
            'content-type': 'multipart/form-data'
          },
          data: data
        }
      }
    }).then(resp => {
      if (!resp.payload.data.success) {
        if (resp.payload.data.errors == ERROR_INCORRECT_FILE_FORMAT) {
          dispatch(Notify.error(ERROR_INCORRECT_FILE_FORMAT))
        }
      } else {
        dispatch(Notify.success(FILE_UPLOAD_SUCCESSFULL))
        dispatch(getUploadLog())
      }
    }).catch(error => {
    })
  }
}

export const uploadManufacturerDb = (data) => {
  return (dispatch, getState) => {
    dispatch({
      type: UPLOAD_MANUFACTURERDB,
      payload: {
        request: {
          url: `/cableinfo`,
          method: 'POST',
          headers: {
            'content-type': 'multipart/form-data'
          },
          data: data
        }
      }
    }).then(resp => {
      if (!resp.payload.data.success) {
        if (resp.payload.data.errors == ERROR_INCORRECT_FILE_FORMAT) {
          dispatch(Notify.error(ERROR_INCORRECT_FILE_FORMAT))
        }
      } else {
        dispatch(Notify.success(FILE_UPLOAD_SUCCESSFULL))
        dispatch(getUploadLog())
      }
    }).catch(error => {

    })
  }
}

export const uploadDeviceSoftware = (data) => {
  return (dispatch, getState) => {
    dispatch({
      type: UPLOAD_DEVICE_SOFTWARE,
      payload: {
        request: {
          url: `/SoftwareUpdate`,
          method: 'POST',
          headers: {
            'content-type': 'multipart/form-data'
          },
          data: data
        }
      }
    }).then(resp => {
      if (!resp.payload.data.success) {
        if (resp.payload.data.errors == ERROR_INCORRECT_FILE_FORMAT) {
          dispatch(Notify.error(ERROR_INCORRECT_FILE_FORMAT))
        }
      } else {
        dispatch(Notify.success(FILE_UPLOAD_SUCCESSFULL))
        dispatch(getUploadLog())
      }
    }).catch(error => {

    })
  }
}

export const uploadfiberfiles = (data) => {
  return (dispatch, getState) => {
    dispatch({
      type: UPLOAD_FIBER_FILES,
      payload: {
        request: {
          url: `/FiberInfo`,
          method: 'POST',
          headers: {
            'content-type': 'multipart/form-data'
          },
          data: data
        }
      }
    }).then(resp => {
      if (!resp.payload.data.success) {
        if (resp.payload.data.errors == ERROR_INCORRECT_FILE_FORMAT) {
          dispatch(Notify.error(ERROR_INCORRECT_FILE_FORMAT))
        }
      } else {
        dispatch(Notify.success(FILE_UPLOAD_SUCCESSFULL))
        dispatch(getUploadLog())
      }
    }).catch(error => {

    })
  }
}

export const UPLOAD_LOG_GET = 'UPLOAD_LOG_GET'

export const getUploadLog = () => ({
  type: UPLOAD_LOG_GET,
  payload: {
    request: {
      mode: 'no-cors',
      url: `uploadlog`,
      method: 'GET'
    }
  }
})

export const uploadAdapterPolicy = (data) => {
  return (dispatch, getState) => {
    dispatch({
      type: UPLOAD_ADAPTER_POLICY,
      payload: {
        request: {
          url: `/cometAdapterPolicy`,
          method: 'POST',
          headers: {
            'content-type': 'multipart/form-data'
          },
          data: data
        }
      }
    }).then(resp => {
      if (!resp.payload.data.success) {
        if (resp.payload.data.errors == ERROR_INCORRECT_FILE_FORMAT) {
          dispatch(Notify.error(ERROR_INCORRECT_FILE_FORMAT))
        }
      } else {
        dispatch(Notify.success(FILE_UPLOAD_SUCCESSFULL))
        dispatch(getUploadLog())
      }
    }).catch(error => {
    })
  }
}
